import { selectors } from 'modules/common';

import { messages } from './columnGroups.messages';
import { ColumnGroup, ColumnGroupItem } from './columnGroups.types';

export const getColumnGroups = (company: selectors.types.ExpandedCompany): ColumnGroupItem[] => {
    const { isXeroMatchingV2ReadOnly, isXeroMatchingV2, isQBooksMatching } = company.flags;

    const columnsGroup = [
        {
            id: ColumnGroup.KeyData,
            text: messages.keyDataText,
        },
        {
            id: ColumnGroup.Workflow,
            text: messages.workflowText,
        },
        {
            id: ColumnGroup.Compliance,
            text: messages.complianceText,
        },
    ];

    if (isXeroMatchingV2ReadOnly || isXeroMatchingV2 || isQBooksMatching) {
        columnsGroup.push({
            id: ColumnGroup.Matching,
            text: messages.matchingText,
        });
    }

    columnsGroup.push(
        {
            id: ColumnGroup.PoDetails,
            text: messages.poDetailsText,
        },
        {
            id: ColumnGroup.QuoteDetails,
            text: messages.quoteDetailsText,
        },
        {
            id: ColumnGroup.BillDetails,
            text: messages.billDetailsText,
        },
        {
            id: ColumnGroup.ExpenseDetails,
            text: messages.expenseDetailsText,
        },
        {
            id: ColumnGroup.SalesInvoiceDetails,
            text: messages.salesInvoiceDetailsText,
        },
        {
            id: ColumnGroup.CreditNotesPayableDetails,
            text: messages.creditNotesPayableDetailsDetailsText,
        },
        {
            id: ColumnGroup.StandaloneWorkflowFields,
            text: messages.standaloneWorkflowFieldsText,
        },
        {
            id: ColumnGroup.LineItemField,
            text: messages.lineItemFieldText,
        },
        {
            id: ColumnGroup.GrnStatus,
            text: messages.grnStatusFieldText,
        },
        {
            id: ColumnGroup.JournalEntryDetails,
            text: messages.journalEntryDetailsText,
        }
    );

    return columnsGroup;
};
